import { render, staticRenderFns } from "./oneGoal.vue?vue&type=template&id=256cc3af&scoped=true"
import script from "./oneGoal.vue?vue&type=script&lang=js"
export * from "./oneGoal.vue?vue&type=script&lang=js"
import style0 from "./oneGoal.vue?vue&type=style&index=0&id=256cc3af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256cc3af",
  null
  
)

export default component.exports